var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20.5466 22.12L14.44 16L20.5466 9.88L18.6666 8L10.6666 16L18.6666 24L20.5466 22.12Z","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }